export default {
    layout: {
        loading: 'Operación en progreso',
        trading: 'Operación en progreso'
    },
    footer: {
    },
    menu: {
        home: 'Inicio',
        staking: 'Matriz',
        port: 'PORT',
        internet: 'Red',
        me: 'Yo',
    },
    header: {
        selectLang: 'Seleccionar idioma',
        close: 'Cerrar',
        trading: 'Trading',
        dashboard: 'Panel',
        subscribeMatrix: 'Suscribir matriz',
        portTaskCenter: 'Centro de tareas PORT',
        network: 'Red',
        apiBinding: 'Vincular API',
        gridTree: 'Árbol de red',
        account: 'Cuenta',
        documents: 'Documentos y Libro Blanco',
        personalCenter: 'Centro personal',
        language: 'Idioma'
    },
    home: {
        recently1:'Comunidad',
        staticrewares: 'Estático',
        recentlyName: 'Libro mayor',
        recentlyInfo: 'Detalles de ganancias',
        dataUpdate: 'Actualización de datos',
        realtime: 'Tiempo real · BSC',
        totalRevenue: 'Ingresos totales (USDT)',
        today: 'Hoy',
        totalTradingVolume: 'Volumen total de operaciones',
        todayEarn: 'Ganancias de hoy',
        share: 'Compartir con amigos',
        shareDesc: 'Comparte tus ganancias y obtén recompensas',
        directReferrals: 'Referidos directos',
        teamMembers: 'Miembros del equipo',
        thisWeek: 'Esta semana',
        copy: 'Copiar',
        recently: 'Ganancias recientes',
        netIncome: 'Ingresos netos',
        dailyAverage: 'Promedio diario',
        quantitativeIncome: 'Ingresos cuantitativos',
        recommend: 'Recomendación',
        port: 'PORT',
        bonus: 'Bonificación',
        all: 'Todo',
        todayTitle: 'Hoy',
        loadingMore: 'Cargar más',
        recommendBonus: 'Bonificación por recomendación',
        portTaskPassed: 'Tarea PORT aprobada',
        myProfit: 'Mis ganancias y pérdidas',
        earningOnBitDeep: 'Estoy ganando con BitDeep',
        totalRevenueUsdt: 'Ingresos totales · USDT',
        consecutiveDays: 'Días consecutivos',
        scanToJoin: 'Escanear para unirse',
        uid: 'UID',
        referralBonus: 'Bonificación por referido',
        shareTo: 'Compartir en',
        eachReferral: 'Recompensa por compartir',
        screenshotAndShare: 'Captura y comparte',
        saveShareEarn: 'Guardar · Compartir · Ganar',
        period: 'Período',
        netProfit: 'Beneficio neto',
        quantReward: 'Ganancia cuantitativa',
        dailyBonus: 'Recompensa diaria PORT',
        close: 'Cerrar',
        permission: 'Permiso',
        onlyEnable: 'Solo habilitar',
        enterBitgetUid: 'Ingrese el UID de BITGET',
        slogan: 'Código',
        document: 'Documento',
        days: 'Días',
        taskText: 'Tarea',
        minutes: 'Minutos',
        decentralizedPortTech: 'Arquitectura tecnológica descentralizada PoRT, tokenómica BGB y matriz de incentivos de doble zona.',
        auditReport: 'Informe de auditoría',
        faqSupport: 'Preguntas frecuentes y soporte',
        telegram: 'Telegram',
        piece: 'Unidad',
        faq: 'Preguntas frecuentes',
        faq1: '¿Cómo vinculo la API de Bitget?',
        faq1Desc: 'Vaya a Bitget Exchange → Configuración → Gestión de API para obtener su API Key y Secret. Active solo los permisos de Spot Trading; nunca active los permisos de retiro. Pegue las claves en BitDeep DApp. Una vez que complete una operación de prueba de 1 USDT, la vinculación se activa.',
        faq2: '¿Qué es PoRT (Prueba de Trading Real)?',
        faq2Desc: 'PoRT es el mecanismo central de "trading como minería". Cada día, el sistema usa su API de Bitget para ejecutar automáticamente operaciones rápidas de compra-venta en una moneda designada (ej. BGB). Cuando el volumen supera Stake × 50%, el sistema lo verifica y activa la recompensa diaria.',
        faq3: '¿Necesito monitorear el mercado manualmente todos los días?',
        faq3Desc: 'No. Una vez vinculada la API, el sistema completa automáticamente la tarea de trading dentro de una ventana de 24 horas. No se requiere acción manual; puede verificar el progreso en el menú PoRT.',
        faq4: '¿Cuál es la diferencia entre ALPHA y SIGMA?',
        faq4Desc: 'ALPHA (Inicial): staking de 500 USDT, rendimiento diario 0.3–1.3%, limitado a 1 plan. SIGMA (Pro): staking de 1,000 USDT, rendimiento diario 0.6–1.6%, hasta 5 planes.',
        faq5: '¿Está seguro mi dinero? ¿Puede la plataforma tocar mis fondos?',
        faq5Desc: 'Sus fondos permanecen al 100% en su propia cuenta de Bitget. La API solo otorga permisos de lectura y trading spot; el sistema no puede retirar ni transferir ningún capital.',
        faq6: '¿Cuándo se liquidan las ganancias diarias?',
        faq6Desc: 'Tras pasar la verificación PoRT, la liquidación ocurre al día siguiente. El sistema libera automáticamente una doble recompensa: ganancias en USDT más puntos 10x Deep.',
        faq7: '¿Cómo se calcula el Bono Scout (Recompensa por Referido Directo)?',
        faq7Desc: 'Por cada cuenta activa que refiera directamente, gana una recompensa diaria fija: 1 USDT/día por referido ALPHA (500 USDT) y 2 USDT/día por referido SIGMA (1,000 USDT), hasta que finalice el ciclo de esa cuenta.',
        faq8: '¿Cómo subo de nivel (D1–D7)?',
        faq8Desc: 'Sube de nivel alcanzando el umbral de volumen total de la zona menor. Ejemplo: D1 requiere 2,000 USDT, D3 requiere 15,000 USDT, D7 (máximo) requiere 3,000,000 USDT. A mayor nivel, mayor bono diferencial (hasta 7 USDT/persona/día en D7).',
        faq9: '¿Cuántos días dura un ciclo? ¿Qué pasa al terminar?',
        faq9Desc: 'Un ciclo dura 28 días. Al finalizar, puede optar por continuar con el staking; las recompensas se pagan según los resultados reales de verificación PoRT diaria (rendimiento variable).',
        faq10: '¿Hay comisiones por retiro?',
        faq10Desc: 'Los retiros tienen cero comisiones. La plataforma redirige las comisiones de retiro al pool para fortalecer la liquidez LP, creando un ciclo virtuoso.',

        bigArea: 'Área grande',
        smallArea: 'Área pequeña',
        enterWithdrawAmount: 'Ingrese el monto a retirar',
        all: 'Todo',
        available: 'Disponible',
        totalAmount: 'Monto total',
        confirmWithdraw: 'Confirmar retiro',
        withdrawRecord: 'Historial de retiros',
        withdrawn: 'Retirado',
        quickStartGuide: 'Guía de inicio rápido',
        whitepaperGuide: 'Libro Blanco y Guía',
        whitepaper: 'Libro Blanco',
        downloadPdf: 'Descargar'
    },
        staking: {
        title: 'Matriz de staking',
        active: 'Activar',
        activated: 'Activado',
        level: 'Nivel',
        cycle: 'Ciclo',
        quantity: 'Cantidad',
        dailyIncome: 'Ingresos diarios',
        totalIncome: 'Ingresos totales',
        progress: 'Progreso',
        remaining: 'Restante',
        expired: 'Expirado',
        buy: 'Comprar',
        stakeNow: 'Hacer staking ahora',
        rules: 'Reglas',
        basic: 'Básico',
        advanced: 'Avanzado',
        days: 'Días',
        maximum: 'Máximo',
        package: 'Paquete',
        packagePlural: 'Paquetes',
        amount: 'Monto',
        incomeRate: 'Tasa de rendimiento',
        current: 'Actual',
        available: 'Disponible',
        locked: 'Bloqueado',
        unlock: 'Desbloquear',
        expected: 'Esperado',
        cumulative: 'Acumulado',
        activateSuccess: 'Activación exitosa',
        activateFail: 'Error de activación',
        insufficientBalance: 'Saldo insuficiente',
        pleaseConnect: 'Por favor conecte la billetera',
        confirm: 'Confirmar',
        cancel: 'Cancelar',
        processing: 'Procesando...',
        completed: 'Completado',
        selectPackage: 'Seleccionar paquete',
        investmentAmount: 'Monto de inversión',
        totalLocked: 'Total bloqueado',
        estimatedProfit: 'Ganancia estimada',
        incomeDescription: 'Las ganancias se calculan diariamente y se distribuyen automáticamente.'
    },

    port: {
        title: 'Centro de tareas PORT',
        taskCenter: 'Centro de tareas',
        todayTask: 'Tarea de hoy',
        completed: 'Completada',
        pending: 'Pendiente',
        processing: 'En proceso',
        startTask: 'Iniciar tarea',
        taskCompleted: 'Tarea completada',
        taskReward: 'Recompensa de tarea',
        rewardReceived: 'Recompensa recibida',
        tradingVolume: 'Volumen de operaciones',
        requiredVolume: 'Volumen requerido',
        todayVolume: 'Volumen de hoy',
        completionRate: 'Tasa de finalización',
        remaining: 'Restante',
        nextReward: 'Próxima recompensa',
        executionTime: 'Tiempo de ejecución',
        executionSuccess: 'Ejecución exitosa',
        executionFail: 'Error de ejecución',
        taskRules: 'Reglas de tarea',
        automaticTrading: 'Trading automático',
        apiConnected: 'API conectada',
        apiNotConnected: 'API no conectada',
        connectApi: 'Conectar API',
        taskStatus: 'Estado de la tarea',
        rewardDetails: 'Detalles de recompensa',
        dailySettlement: 'Liquidación diaria',
        todayReward: 'Recompensa de hoy',
        cumulativeReward: 'Recompensa acumulada',
        viewDetails: 'Ver detalles'
    },

    network: {
        title: 'Red',
        directReferrals: 'Referidos directos',
        teamSize: 'Tamaño del equipo',
        totalPerformance: 'Rendimiento total',
        todayPerformance: 'Rendimiento de hoy',
        activeMembers: 'Miembros activos',
        inactiveMembers: 'Miembros inactivos',
        teamReward: 'Recompensa del equipo',
        recommendationReward: 'Recompensa por recomendación',
        peerReward: 'Recompensa de mismo nivel',
        differenceReward: 'Recompensa diferencial',
        totalReward: 'Recompensa total',
        myInviter: 'Mi patrocinador',
        inviteLink: 'Enlace de invitación',
        inviteCode: 'Código de invitación',
        copyLink: 'Copiar enlace',
        copySuccess: 'Copiado con éxito',
        registrationCount: 'Número de registros',
        validMembers: 'Miembros válidos',
        totalIncome: 'Ingresos totales',
        memberList: 'Lista de miembros',
        joinTime: 'Hora de registro',
        status: 'Estado',
        active: 'Activo',
        inactive: 'Inactivo'
    },

    api: {
        title: 'Vinculación API',
        exchange: 'Exchange',
        apiKey: 'API Key',
        secretKey: 'Secret Key',
        passphrase: 'Passphrase',
        bind: 'Vincular',
        unbind: 'Desvincular',
        bindSuccess: 'Vinculación exitosa',
        bindFail: 'Error de vinculación',
        updateSuccess: 'Actualización exitosa',
        pleaseInputApi: 'Ingrese API Key',
        pleaseInputSecret: 'Ingrese Secret Key',
        pleaseInputPassphrase: 'Ingrese Passphrase',
        connectionStatus: 'Estado de conexión',
        connected: 'Conectado',
        disconnected: 'Desconectado',
        testConnection: 'Probar conexión',
        connectionSuccess: 'Conexión exitosa',
        connectionFail: 'Error de conexión',
        permissionTip: 'Solo habilite permisos de trading spot y nunca habilite retiros.',
        securityTip: 'Tus fondos permanecen en tu cuenta de exchange y no pueden ser retirados por la plataforma.',
   close: 'Cerrar',
withdraw: 'Retirar',
permission: 'Permisos',
onlyEnable: 'Habilitar solo',
spotTrading: 'Trading Spot',
read: 'Lectura',
recommendedPartner: 'Socio recomendado',
zeroFee: '0% de comisión',
activated: 'Activado',
classicAccount: 'Cuenta clásica',
unifiedAccount: 'Cuenta unificada',
bindBitgetApi: 'Vincular API de Bitget',
upcoming: 'Próximamente',
underAudit: 'En auditoría de integración',
expected: 'Estimado'
},

port: {
    portTaskCenter: 'Centro de tareas PORT',
    dailyTask: 'Tarea diaria',
    verify: 'Verificar',
    completed: 'Completado',
    incomplete: 'Incompleto',
    verifyStandard: 'Criterio de verificación',
    tradingVolume: 'Volumen de operaciones',
    today: 'Hoy',
    deadline: 'Fecha límite',
    reward: 'Recompensa',
    startVerify: 'Iniciar verificación',
    verifying: 'Verificando',
    verified: 'Verificado',
    insufficient: 'No alcanzado',
    viewDetails: 'Ver detalles',
    taskList: 'Lista de tareas',
    allTasks: 'Todas las tareas',
    completedTasks: 'Tareas completadas',
    pendingTasks: 'Tareas pendientes',
    proofOfRealTrading: 'Prueba de trading real',
    todayTask: 'Tarea de hoy',
    todayStaticIncome: 'Ingresos estáticos de hoy',
    points: 'Puntos',
    todayWindowClosesAt: 'La ventana de hoy cierra a las',
    checkTaskStatus: 'Verificar estado de la tarea',
    teamProgress: 'Progreso del equipo · Hoy',
    realtimePortCompletion: 'Estado PORT en tiempo real',
    completedText: 'Completado',
    pendingText: 'Pendiente',
    realtimeApiValidationFlow: 'Tiempo real · API · Flujo de validación',

    rewardRemark1: 'Dividendos globales',
    rewardRemark2: 'Bono diferencial',
    rewardRemark3: 'Bono de recomendación',
    rewardRemark4: 'Recompensa por tarea',
    rewardRemark5: 'Tarea PoRT aprobada',
},

internet: {
    network: 'Red',
    treeBrowser: 'Navegador de árbol',
    searchAddress: 'Buscar dirección 0x... o BD-ID',
    totalTradingVolume: 'Volumen total de operaciones',
    members: 'miembros',
    networkStructure: 'Estructura de la red',
    allLevels: 'Todos los niveles',
    addRemark: 'Agregar nota',
    enterRemark: 'Ingrese una nota',
    cancel: 'Cancelar',
    confirm: 'Confirmar',
},

withdraw: {
    withdraw: 'Retirar',
    usdtAsset: 'Activos USDT',
    withdrawAmount: 'Monto a retirar',
    availableBalance: 'Saldo disponible',
    fee: 'Comisión',
    actualArrival: 'Monto recibido',
    submit: 'Enviar',
    withdrawSuccess: 'Éxito',
    withdrawFailed: 'Fallido',
    processing: 'Procesando',
    completed: 'Completado',
    withdrawHistory: 'Historial de retiros'
},

popup: {
    taskUnfinished: 'Tarea no completada',
    taskUnfinishedDesc: 'Los datos de trading no cumplen con el estándar de verificación PoRT de hoy',
    todayTradingVolume: 'Volumen de operaciones de hoy',
    remaining: 'Falta',
    toComplete: 'para completar la tarea de hoy',
    tradingVolumeThreshold: '',
    deadline: 'Tiempo restante hasta el cierre de la tarea',
    tryAgain: 'Inténtelo más tarde',
    goTrade: 'Ir a operar',

    taskCompleted: 'Verificación de tarea aprobada',
    taskCompletedDesc: 'La prueba de trading PoRT de hoy se ha registrado correctamente en la blockchain',
    rewardIssued: 'Recompensa distribuida',
    complete: 'Completar',

    shareTitle: 'Compartir invitación',
    shareDesc: 'Invita a tus amigos a registrarse y ambos recibirán recompensas',
    referralLink: 'Enlace de invitación',
    qrCode: 'Código QR',
    copyLink: 'Copiar enlace',
},
}